// CourseCard.js
import React from "react";
import DOMPurify from "dompurify";
import "../../css/courseCard.css";
const CourseCard = ({ course, onClick }) => {
  // تابع برای ایجاد خلاصه از محتوای HTML
  const createExcerpt = (html, maxLength = 100) => {
    // حذف تگ‌های HTML و دریافت متن خالص
    const plainText = html.replace(/<[^>]*>/g, "");

    // ایجاد خلاصه اگر متن طولانی باشد
    if (plainText.length <= maxLength) return plainText;
    return plainText.substring(0, maxLength) + "...";
  };
  // console.log(course.icon)
  return (
    <div className="course-card card mx-auto" onClick={onClick}>
      <div className="course-image"><img src={course.icon} /></div>
      <div className="p-6">
        <div className="flex items-center justify-between mb-4">
          <span className={`course-level ${course.level}`}>
            {course.levelName}
          </span>
          <div className="course-meta">
            <span>⭐ {course.rating}</span>
          </div>
        </div>
        <h3 className="text-xl font-bold text-dark mb-3 leading-tight">
          {course.title}
        </h3>

        {/* نمایش خلاصه‌ای از محتوای HTML به صورت امن */}
        <div
          className="text-gray-600 mb-4 leading-relaxed"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(createExcerpt(course.description || "")),
          }}
        ></div>

        <div className="course-meta mb-4">
          <span>⏱️ {course.duration}</span>
          <span>•</span>
          {/* <span>👥 {course.students}</span> */}
        </div>
        <div className="flex items-center justify-between">
          <div className={`course-price ${course.isFree ? "free" : ""}`}>
            {course.isFree ? (
              <div className="course-price">
                <span className="free-badge">رایگان</span>
              </div>
            ) : (
              <div className="course-price-container">
                {parseFloat(course.discount) > 0 ? (
                  <>
                    <div className="discount-badge">{course.discount}%</div>
                    <div className="price-wrapper">
                      <span className="original-price-card">
                        {parseFloat(course.price).toLocaleString()} تومان
                      </span>
                      <span className="final-price-card">
                        {course.finalPrice.toLocaleString()} تومان
                      </span>
                    </div>
                  </>
                ) : (
                  <span className="regular-price">
                    {parseFloat(course.price).toLocaleString()} تومان
                  </span>
                )}
              </div>
            )}
          </div>
          <button className="btn-view-course btn-primary px-4 py-2 rounded-xl font-bold transition-all">
            مشاهده دوره
          </button>
        </div>
      </div>
    </div>
  );
};

export default CourseCard;
